import Plugin from 'src/plugin-system/plugin.class';
import 'src/helper/readmore.helper';

export default class ReadMorePlugin extends Plugin {

    init() {

        $(this.el).readmore({
            collapsedHeight: this.options.height,
            lessLink: '<a href="#" class="read-more__less">Weniger lesen</a>',
            moreLink: '<a href="#" class="read-more__more">Mehr lesen</a>'
        });
    }

}